
































import * as _ from 'lodash';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import $ from 'jquery';
import StateBar from '@/components/mobile/basics/StateBar.vue';
import { Language, VisitorType, WindowState } from '../../../types/Enum';


@Component({
  components: {
    StateBar,
  },
})
export default class LockedScreen extends Vue {
    private start: boolean = false;

    private login: boolean = false;

    private today: Date = new Date();

    private hours: string = '';

    private date: string = '';

    private days: string[] = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

    private months:string[] = ['Janvier', 'Fevr', 'Mardi', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Saptembre', 'Octobre', 'Novembre', 'Decembre'];

    private visitor: VisitorType = VisitorType.None;

    private showNotification: boolean = false;

    private handlerSwipe(direction: any) {
      // this.$root.$emit("LockedScreen::Unlock");
    }

    public getDate() : string {
      return `${this.days[this.today.getDay()]} ${this.today.getDate()} ${this.months[this.today.getMonth()]}`;
    }

    public getHours() : string {
      const pad:Function = (nbr: number) => ((nbr < 10) ? `0${nbr}` : `${nbr}`);
      return `${pad(this.today.getHours())}:${pad(this.today.getDate())}`;
    }

    private logUser() {
      const element: Element = (this.$refs.noblured as Element);
      this.login = !this.login;
      setTimeout(() => {
        this.$root.$emit('TypeWritter::Animation::End');
      }, 2000);
    }

    public mounted() {
      this.today = new Date();
      this.$root.$on('App::Animation::End', () => {
        this.start = true;
      });
      setInterval(() => {
        this.date = this.getDate();
        this.hours = this.getHours();
      }, 1000);
      setTimeout(() => {
          this.showNotification = true;
      }, 5000);
    }

    private setVisitor(type: VisitorType): void {
      this.visitor = type;
    }
}
